<template>
  <div class="border-b attributes flex justify-between pb-4 mb-6">
    <div class="attributes__action mt-8" >
      <span v-if="action === 'create'">
        <i v-show="level !== 1" @click="remove" class="cursor-pointer el-icon-remove-outline text-2xl"></i>
      </span>
      <span v-else>
        <i v-if="isNewAttribute" @click="remove" class="cursor-pointer el-icon-remove-outline text-2xl"></i>
        <span v-else>
          <span v-if="!loading">
            <i v-show="!isNewAttribute" @click="deleteAttribute" class="cursor-pointer el-icon-delete text-red-500 text-2xl"></i>
          </span>
          <vue-loaders v-else name="line-scale-pulse-out-rapid" color="red" scale="0.5"></vue-loaders>
        </span>
      </span>

    </div>
    <div class="attributes__input mb-4">
      <label class="block text-gray-700 text-sm mb-1">
        Attribute Group
      </label>
      <el-select class="w-full" @change="disabled = false" v-model="attributeGroupId" placeholder="Select Attribute Group">
        <el-option
          v-for="group in groups"
          :key="group.value"
          :label="group.label"
          :value="group.value">
        </el-option>
      </el-select>
    </div>
    <div class="attributes__input mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-1">
        Name
      </label>
      <el-input placeholder="e.g Blue " v-model="name"></el-input>
      <p v-if="!$v.name.required" class="text-red-500 text-xs italic mt-1">Name is required</p>
    </div>
    <div class="attributes__input mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-1">
        Price <span class="text-xs italic">(added to the main price)</span>
      </label>
      <el-input placeholder="e.g 200 " v-model="price"></el-input>
      <p v-if="!$v.price.decimal" class="text-red-500 text-xs italic mt-1">Please provide integer only</p>
    </div>
    <div class="attributes__action mt-8">
      <i  v-show="count === level" @click="add()" class="el-icon-circle-plus-outline text-2xl"></i>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import productForm from '../../../../helper/form-validations';

export default {
  name: 'Attributes',
  data() {
    return {
      disabled: true,
      loading: false,
    };
  },
  mixins: [validationMixin],
  validations: {
    ...productForm.attribute,
  },
  props: {
    count: {
      type: Number,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    action: {
      type: String,
      default: 'create',
    },
  },
  computed: {
    key() {
      return this.level - 1;
    },

    groupIsSelected() {
      return this.attributeGroupId !== null;
    },

    attributeGroupId: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].attributes[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].attributes[this.key].attribute_group_id || null;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'attributes', key: this.key, property: 'attribute_group_id', payload: value,
        });
        this.$emit('isDirty', !this.$v.name.$invalid);
      },
    },

    name: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].attributes[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].attributes[this.key].name || null;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'attributes', key: this.key, property: 'name', payload: value,
        });
        this.$emit('isDirty', !this.$v.name.$invalid);
      },
    },

    price: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].attributes[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].attributes[this.key].price || null;
        }

        return 0;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'attributes', key: this.key, property: 'price', payload: value,
        });
        this.$emit('isDirty', !this.$v.price.$invalid);
      },
    },

    groups() {
      return this.$store.getters['InventoryModule/Attributes/groupsForSelect'];
    },

    isNewAttribute() {
      const attribute = this.$store.state.InventoryModule.Products[this.action].attributes[this.key];
      if (attribute && Object.keys(attribute).length > 0) {
        return !attribute.id;
      }

      return true;
    },
  },
  methods: {
    add() {
      this.$store.commit('InventoryModule/Products/setActionMultipleProperty', {
        action: this.action, parent: 'attributes', payload: { [this.level]: {} },
      });
      this.$emit('add');
    },
    remove() {
      this.$store.commit('InventoryModule/Products/removeProductMultipleData', {
        action: this.action, parent: 'attributes', key: this.key, index: this.level,
      });
      this.$emit('minus');
    },

    async deleteAttribute() {
      this.loading = true;
      const attributeId = this.$store.state.InventoryModule.Products[this.action].attributes[this.key].id;
      try {
        await this.$store.dispatch('InventoryModule/Products/deleteItemAttribute', { attributeId, productId: this.$route.params.id });
        await this.remove();
        this.$notify.success({
          title: 'Success',
          message: 'Attribute Successfully Deleted',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.attributes {
  .attributes__action {
    flex: 0 1 3%
  }

  .attributes__input {
    flex: 0 1 30%;
  }
}
</style>
